var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { DropdownSelect } from '@dixa/lib-shared-habla';
import classnames from 'classnames';
import { useCallback, useMemo, useState } from 'react';
import { v4 as uuid } from 'uuid';
import { VariableSelectorItem } from './components/item/item';
export const VariableSelector = (_a) => {
    var { className, variables, children, withSearch, onSelect } = _a, otherProps = __rest(_a, ["className", "variables", "children", "withSearch", "onSelect"]);
    const handleSelect = useCallback((variable) => {
        if ('content' in variable) {
            onSelect(variable.name, variable.content);
        }
    }, [onSelect]);
    const [search, setSearch] = useState('');
    const filteredItems = useMemo(() => {
        const items = [];
        variables.forEach((variable) => {
            const filteredItems = variable.items
                .filter((variable) => {
                if (!!search && typeof variable.name === 'string') {
                    return (variable.name.toLowerCase().indexOf(search.toLowerCase()) !== -1);
                }
                return true;
            })
                .map((variable) => (Object.assign(Object.assign({}, variable), { id: typeof variable.name === 'string' ? variable.name : uuid(), matched: search })));
            if (items.length > 0 && filteredItems.length) {
                items.push({
                    id: variable.label,
                    name: variable.label,
                    divider: true,
                });
            }
            items.push(...filteredItems);
        });
        return items;
    }, [variables, search]);
    const rootClass = classnames(className);
    return (_jsx("div", Object.assign({}, otherProps, { className: rootClass }, { children: _jsx(DropdownSelect, Object.assign({ itemComponent: VariableSelectorItem, items: filteredItems, noStyle: true, hasSearch: withSearch, onSearch: setSearch, onSelect: handleSelect, fixed: true, containerProps: { style: { width: '300px' } } }, { children: children })) })));
};
